<template>
  <div class="wysiwyg">
    <p v-if="loading">
      <slot></slot>
    </p>
    <div v-else v-html="content"></div>
  </div>
</template>

<script>
export default {
  props: {
    slug: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'string',
    },
  },

  data() {
    return {
      content: null,
      loading: true,
    };
  },

  created() {
    this.getContent();
  },

  methods: {
    getContent() {
      axios
        .get(`/json/copy/${this.slug}/html`)
        .then((response) => {
          if (response.status !== 200) {
            throw 'Network error.';
          }

          this.content = response.data;
        })
        .catch((e) => {
          console.error(e);
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
};
</script>
